<template>
  <FilterBadge
    v-bind="{ ...$props, ...$attrs }"
    class="quick-search-filter-badge"
    color="var(--p-primary-color)"
    icon="fas fa-infinity"
  >
    {{ filter.searchText }}
  </FilterBadge>
</template>

<script setup lang="ts">
import type { PropType } from "vue";
import FilterBadge from "./FilterBadge.vue";
import QuickSearchFilter from "../../filterImplementations/QuickSearchFilter";

defineProps({
  filter: {
    type: Object as PropType<QuickSearchFilter>,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
.quick-search-filter-badge {
  color: var(--p-primary-contrast-color);
}
</style>
